export default __webpack_public_path__ + "3bd41a55cf24ab4673fdedfdf8166770.png";